const PaperTypeIcon = ({ value }) => (
  <div className="dot bigger paper">
    <div>{value}</div>
  </div>
)

export default PaperTypeIcon
